'use strict';

const init = () => {
    const video = document.getElementById('banner-video')

    if (video) {
        const fadeTime = 1
        let isFadingOut = false

        video.addEventListener("timeupdate", () => {
            if (video.duration - video.currentTime <= fadeTime && !isFadingOut) {
                video.style.opacity = "0"
                isFadingOut = true
            }

            if (video.currentTime < 0.1 && isFadingOut) {
                video.style.opacity = "1"
                isFadingOut = false
            }
        })
    }
}

export default { init }
